export default "__VITE_ASSET__DWHnLpjn__"